import { render } from "./GreenEconomy.vue?vue&type=template&id=1b05e66d&scoped=true"
import script from "./GreenEconomy.vue?vue&type=script&lang=js"
export * from "./GreenEconomy.vue?vue&type=script&lang=js"

import "./GreenEconomy.vue?vue&type=style&index=0&id=1b05e66d&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b05e66d"]])

export default __exports__